import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyD5930l1f4mklhZxumiB3Svuk8jkm5Qyk4",
    authDomain: "aisenhour24.firebaseapp.com",
    projectId: "aisenhour24",
    storageBucket: "aisenhour24.appspot.com",
    messagingSenderId: "628306440125",
    appId: "1:628306440125:web:a700e03a57bafc1f786cd4",
    measurementId: "G-X5QL9FQ5GT"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { db, auth, googleProvider };